import React from "react";
import styled from "styled-components";
import { Button } from "react-bootstrap";

const Styled = {};

Styled.BodyWrapper = styled.div`
  background: #fafafa;
  padding: 24px 36px 16px;
  width: 100%;

  .loader {
    max-width: 800px;

    .loader-inner {
      div {
        margin-left: auto;
        margin-right: auto;
        margin-top: 100px;
        border-color: #2a4169;
      }
    }
  }
`;

Styled.TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 2;
`;

Styled.Title = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 24px;
  line-height: 29px;
  color: #000;
  padding-right: 20px;
`;

Styled.SubmitDecisionButton = styled.div`
  display: inline-block;
  height: 23px;
  width: 148px;
  line-height: 23px;
  text-align: center;
  font-family: Lato;
  font-weight: bold;
  font-size: 14px;
  color: #fff;
  background-color: ${({ submitted }) =>
    submitted ? "#52c5cd" : "rgba(255, 0, 0, 0.75)"};
  border-radius: 5px;

  .fa-spinner,
  .fa-check {
    margin-right: 10px;
  }

  &:hover {
    cursor: pointer;
  }
`;

Styled.ButtonsWrapper = styled.div`
  padding: 0 2px;
`;

Styled.ButtonsWrapperFlex = styled.div`
  display: flex;
  align-items: center;
`;

Styled.UIButton = styled(({ isSmaller, ...props }) => <Button {...props} />)`
  display: block;
  padding: 0 20px !important;
  min-width: auto !important;
  border-color: transparent !important;
  min-width: 156px !important;
  height: 43px !important;
  line-height: 43px !important;
  background-color: #2a4169 !important;
  font-family: Lato !important;
  font-weight: bold !important;
  font-size: 14px !important;
  color: #fff !important;
  border-radius: 4px !important;
  transition: background-color 0.5s ease;

  ${p =>
    p.isSmaller &&
    `
    font-size: 18px !important;
    width: 139px !important;
    height: 30px !important;
    line-height: 30px !important;
  `}

  &:hover {
    background-color: #0da6ad !important;
  }

  &:disabled {
    background-color: #cccccc !important;
  }

  &.active {
    background-color: #0da6ad !important;
  }
`;

Styled.Arrow = styled.div`
  margin-left: 20px;
  margin-right: 20px;
`;

Styled.CashBalanceRow = styled.div`
  margin-top: 30px;
  display: flex;
  align-items: center;
`;

Styled.CashBalanceTitle = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 24px;
  line-height: 29px;
  color: #000;
  padding-right: 15px;
`;

Styled.WhiteBlock = styled.div`
  background: #fff;
  width: 100%;
  margin-top: 22px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  max-width: 800px;
  padding: 25px 40px 60px;
  border-radius: 6px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
`;

Styled.Title1 = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  color: #000;
`;

Styled.Title2 = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  color: #000;
  margin-top: 40px;
  display: flex;
  align-items: center;

  .fa {
    font-size: 16px !important;
    color: #8894a7 !important;
  }
`;

Styled.HelpIcon = styled.img`
  width: 14px;
  height: 14px;
  margin-left: 4px;
  cursor: pointer;
`;

Styled.HelpIconInline = styled.img`
  width: 12px;
  height: 12px;
  margin-left: 4px;
  cursor: pointer;
  vertical-align: middle;
`;

Styled.ModalVideoWrapper = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #3A507B;
  border-radius: 10px;

  &:before {
    display: block;
    content: '';
    align-items: center;
    background: #0006;
    display: flex;
    justify-content: center;
    opacity: 1;
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0px;
    bottom: 0px;
    transition: opacity .3s ease;
    border-radius: 10px;
  }

  &.is-playing:before, &.is-playing button {
    opacity: 0;
  }
  &.is-playing:hover:before, &.is-playing:hover button {
    opacity: 1;
  }
  &:hover video {
    cursor: pointer;
  }
`;

Styled.PlayPauseButton = styled.button`
  align-items: center;
  background: none;
  background: #2a4169;
  border: none;
  border-radius: 50%;
  box-shadow: 0 4px 4px 0 #0000001a;
  color: #fff;
  cursor: pointer;
  display: flex;
  font-size: 2rem;
  height: 80px;
  justify-content: center;
  padding: 0;
  text-align: center;
  width: 80px;
  z-index: 2;
  position: absolute;
  transition: opacity .3s ease;
  opacity: 1;
`;

Styled.CloseModalVideoButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 20px;
  color: #fff;
  padding: 0;
  line-height: normal;
`;

Styled.AmountsRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 34px;
`;

Styled.AmountsColumn1 = styled.div``;
Styled.AmountsColumn2 = styled.div`
  padding-left: 40px;
`;

Styled.Title3 = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  color: #000;
  display: flex;
  align-items: center;

  .fa {
    font-size: 16px !important;
    color: #8894a7 !important;
  }
`;

Styled.Title4 = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  color: #000;

  .fa {
    font-size: 16px !important;
    color: #8894a7 !important;
  }
`;

Styled.Amount = styled.div`
  padding-top: 15px;
  font-family: Lato;
  font-weight: bold;
  font-size: 30px;
  line-height: 36px;
  color: #000;
  text-align: center;
  display: none;

  ${p =>
    p.shown &&
    `
    display: block;
  `}

  ${p => p.negative && `
    color: #ff4d4f;
  `}
`;

Styled.Chart = {};

Styled.Chart.Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 10px;
  position: relative;
  z-index: 1;
`;

Styled.Chart.Chart = styled.div`
  flex: 0 0 408px;
`;

Styled.Chart.Legend = styled.div`
  margin-top: -10px;
`;

Styled.Chart.LegendItem = styled.div`
  font-family: Lato;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #000000;
  display: flex;
  align-items: center;
  margin-top: 10px;

  ${p =>
    p.bold &&
    `
    font-weight: bold;
  `}
`;

Styled.Chart.LegendItemCircle = styled.div`
  width: 15px;
  height: 15px;
  ${p =>
    p.color &&
    `
    background: ${p.color};
  `};
  margin-right: 13px;
  content: "";
  border-radius: 15px;
`;

/* ----- Redesign: subtitle, KPI cards, capital structure, summary tables ----- */

Styled.Subtitle = styled.div`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: rgba(0, 27, 59, 0.7);
  margin-top: 4px;
  margin-bottom: 12px;
`;

Styled.KpiRow = styled.div`
  display: grid;
  grid-template-columns: ${p => p.cardCount === 3 ? 'repeat(3, 1fr)' : '1fr 1fr 1fr 0.7fr 1fr'};
  gap: 12px;
  margin-bottom: 16px;
  max-width: 1300px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

Styled.KpiCard = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 14px 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: 84px;
`;

Styled.KpiLabel = styled.div`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: rgba(0, 27, 59, 0.6);
  display: flex;
  align-items: center;
`;

Styled.KpiValue = styled.div`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  color: rgba(0, 27, 59, 0.94);
`;

Styled.HealthBadge = styled.span`
  display: inline-block;
  margin-top: 6px;
  padding: 3px 10px;
  border-radius: 12px;
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  align-self: flex-start;

  ${p => p.status === 'Healthy' && `
    color: #2DA548;
    background: #E8F5EC;
  `}
  ${p => p.status === 'Moderate' && `
    color: #B25F00;
    background: #FFF1DD;
  `}
  ${p => p.status === 'High' && `
    color: #C62828;
    background: #FDECEA;
  `}
  ${p => p.status === 'Very High' && `
    color: #ffffff;
    background: #8E1A1A;
  `}
`;

Styled.SectionCard = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 18px 22px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  margin-bottom: 16px;
  max-width: 1300px;
`;

Styled.SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;

Styled.SectionTitle = styled.h2`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 26px;
  color: rgba(0, 27, 59, 0.94);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 6px;
`;

Styled.SectionSubtitle = styled.div`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 4px;
`;

Styled.SectionSubtitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
  margin-top: 4px;
`;

Styled.SectionSubtitleRow_Inner = styled.div`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: rgba(0, 27, 59, 0.6);
`;

Styled.SectionSubtitleValue = styled.div`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: rgba(0, 27, 59, 0.94);
`;

Styled.DonutWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;

  @media (max-width: 700px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

Styled.DonutChart = styled.div`
  width: 160px;
  height: 160px;
  flex-shrink: 0;
  position: relative;
`;

Styled.DonutCenter = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  pointer-events: none;
`;

Styled.DonutCenterLabel = styled.div`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.6);
`;

Styled.DonutCenterValue = styled.div`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
  color: rgba(0, 27, 59, 0.94);
  white-space: nowrap;
`;

Styled.DonutLegend = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

Styled.LegendRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

Styled.LegendRowTop = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

Styled.LegendDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${p => p.color || '#000'};
`;

Styled.LegendLabel = styled.div`
  flex: 1;
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: rgba(0, 27, 59, 0.94);
`;

Styled.LegendValue = styled.div`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: rgba(0, 27, 59, 0.94);
`;

Styled.LegendPercent = styled.div`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  color: rgba(0, 27, 59, 0.6);
  width: 40px;
  text-align: right;
`;

Styled.LegendBar = styled.div`
  height: 4px;
  background: #F0F0F0;
  border-radius: 2px;
  overflow: hidden;
`;

Styled.LegendBarFill = styled.div`
  height: 100%;
  background: ${p => p.color || '#000'};
  width: ${p => p.percentage || 0}%;
`;

Styled.SummaryTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: 'Mukta Vaani', Lato, sans-serif;
`;

Styled.SummaryHeadRow = styled.tr`
  border-bottom: 1px solid #ECEDEF;
`;

Styled.SummaryHeadCell = styled.th`
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: rgba(0, 27, 59, 0.6);
  padding: 8px 14px 4px 0;
  text-align: ${p => p.align || 'left'};

  &:last-child {
    padding-right: 0;
  }
`;

Styled.SummaryRow = styled.tr`
  border-bottom: 1px solid #F5F6F7;

  &:last-child {
    border-bottom: none;
  }
`;

Styled.SummaryCell = styled.td`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 27, 59, 0.94);
  padding: 8px 14px 8px 0;
  text-align: ${p => p.align || 'left'};

  &:last-child {
    padding-right: 0;
  }
`;

// Money-with-aligned-$ pair: lays out a dollar sign on the left and a
// fixed-width amount slot on the right so the $ stays at the same x
// across rows even when number magnitudes differ.
Styled.MoneyAligned = styled.span`
  display: inline-flex;
  align-items: baseline;
  font-variant-numeric: tabular-nums;
`;

Styled.MoneyPrefix = styled.span`
  margin-right: 2px;
`;

Styled.MoneyAmount = styled.span`
  display: inline-block;
  min-width: 9ch;
  text-align: right;
`;

Styled.SummaryFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  margin-top: 6px;
  border-top: 1px solid #ECEDEF;
`;

Styled.SummaryFooterLabel = styled.div`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 27, 59, 0.94);
  display: flex;
  align-items: center;
  gap: 6px;
`;

Styled.SummaryFooterValue = styled.div`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #2A4169;
`;

Styled.SectionHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
`;

Styled.SectionHeaderRight = styled.div`
  text-align: right;
`;

Styled.SectionHeaderRightLabel = styled.div`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.6);
`;

Styled.SectionHeaderRightValue = styled.div`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #2A4169;
  margin-top: 2px;
`;

/* ----- Choose Your Lender (Debt Decisions) modal ----- */

Styled.LenderOverlay = styled.div`
  position: fixed;
  top: 59px;
  left: 0;
  right: 0;
  bottom: 0;
  background: #F5F6F7;
  z-index: 1500;
  overflow-y: auto;
  font-family: 'Mukta Vaani', Lato, sans-serif;

  /* Every per-page decision-page CloseButton uses aria-label="Close".
     Style them uniformly from the shared overlay so the "x" reads
     as an actual clickable button (white circle around it) at a
     consistent size across all pages (20% larger than the original
     naked 24px glyph). */
  button[aria-label="Close"] {
    background: #3a507b;
    border: 1px solid #3a507b;
    border-radius: 50%;
    width: 44px;
    height: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 29px;
    line-height: 1;
    color: #FFFFFF;
    cursor: pointer;
    padding: 0;
    transition: background 0.15s ease, border-color 0.15s ease;

    &:hover {
      background: #2a4169;
      border-color: #2a4169;
    }

    &:focus-visible {
      outline: 2px solid #2563EB;
      outline-offset: 2px;
    }
  }
`;

Styled.LenderModalHeader = styled.div`
  position: relative;
  padding: 32px 48px 12px;
  text-align: center;
`;

Styled.LenderModalTitle = styled.h2`
  font-weight: 700;
  font-size: 28px;
  line-height: 34px;
  color: rgba(0, 27, 59, 0.94);
  margin: 0;
`;

Styled.LenderModalSubtitle = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 8px;
`;

Styled.LenderModalClose = styled.button`
  /* Positioning only. Visual styling (white circle + sized "x")
     comes from the shared button[aria-label="Close"] rule on
     Styled.LenderOverlay so every decision page's close button
     looks and sizes the same. */
  position: absolute;
  top: 24px;
  right: 24px;
`;

Styled.LenderStatusBar = styled.div`
  margin: 16px 150px 24px;
  background: #fff;
  border-radius: 12px;
  padding: 20px 28px;
  display: flex;
  align-items: flex-start;
  gap: 32px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
`;

Styled.LenderStatusLeft = styled.div`
  display: flex;
  gap: 24px;
  flex-shrink: 0;
`;

Styled.LenderStatusItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-right: 24px;
  border-right: ${p => p.divider ? '1px solid #DEE0E3' : 'none'};
`;

Styled.LenderStatusLabel = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.6);
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;

Styled.LenderStatusValue = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  color: rgba(0, 27, 59, 0.94);
`;

Styled.LenderStatusRight = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
`;

Styled.LenderStatusRightLabel = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.6);
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-bottom: 10px;
`;

Styled.LenderStatusRightCurrent = styled.div`
  position: absolute;
  top: 0;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  color: rgba(0, 27, 59, 0.94);
  transform: translateX(-50%);
  white-space: nowrap;
`;

Styled.LenderRatioBar = styled.div`
  position: relative;
  height: 6px;
  border-radius: 3px;
  background: #DEE0E3;
  overflow: visible;
  display: flex;
`;

Styled.LenderRatioSegment = styled.div`
  height: 100%;
  background: ${p => p.color};
  width: ${p => p.width}%;
  position: relative;

  &:first-child {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }
`;

Styled.LenderRatioMarker = styled.div`
  position: absolute;
  top: 12px;
  white-space: nowrap;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: ${p => p.color};
  transform: translateX(-50%);
  left: ${p => p.position}%;
`;

Styled.LenderRatioDot = styled.div`
  position: absolute;
  top: -3px;
  right: 0;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(0, 27, 59, 0.94);
  border: 2px solid #fff;
  transform: translateX(-50%);
`;

Styled.LenderGrid = styled.div`
  padding: 0 150px 48px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`;

const cardThemes = {
  green: { border: '#2DA548', bg: '#EAF3EC', accent: '#2DA548', innerBg: '#FFFFFF', badgeBg: '#D1E9D6' },
  yellow: { border: '#F9C151', bg: '#FFF8EB', accent: '#D69100', innerBg: '#FFFFFF', badgeBg: '#FBEDD5' },
  red: { border: '#FF5252', bg: '#FAEDED', accent: '#C62828', innerBg: '#FFFFFF', badgeBg: '#FBD8D8' }
};

Styled.LenderCard = styled.div`
  background: ${p => cardThemes[p.theme || 'green'].bg};
  border: 1px solid ${p => cardThemes[p.theme || 'green'].border};
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;

  ${p => p.noAnimation
    ? `opacity: 1;`
    : `
      opacity: 0;
      animation: fadeInLender 0.5s ease forwards;
      animation-delay: ${(p.index || 0) * 500}ms;
    `}

  @keyframes fadeInLender {
    from {
      opacity: 0;
      transform: translateY(8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

Styled.LenderCardTop = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 14px;
`;

Styled.LenderLogo = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 8px;
  background: #fff;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

Styled.LenderTitleArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

Styled.LenderName = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: rgba(0, 27, 59, 0.94);
`;

Styled.LenderTagline = styled.div`
  font-style: italic;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: rgba(0, 27, 59, 0.6);
`;

Styled.LenderRiskBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  padding: 3px 10px;
  border-radius: 5px;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  background: ${p => cardThemes[p.theme || 'green'].badgeBg};
  color: ${p => cardThemes[p.theme || 'green'].accent};
  align-self: flex-start;

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${p => cardThemes[p.theme || 'green'].accent};
  }
`;

Styled.LenderDescription = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 27, 59, 0.7);
  margin: 0 0 14px;
`;

Styled.LenderInnerCard = styled.div`
  background: #fff;
  border-radius: 5px;
  padding: 14px 16px;
  margin: 0 0 12px;
`;

Styled.LenderInnerLabel = styled.div`
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.6px;
  color: rgba(0, 27, 59, 0.94);
  text-transform: uppercase;
  margin-bottom: 10px;
`;

Styled.LenderOfferRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;

  /* Center-align label + value in the Interest Rate and D/C Limit
     columns (cols 2 and 3) so the value sits directly under its
     header. Max Loan (col 1) stays left-aligned. */
  > div:nth-child(2),
  > div:nth-child(3) {
    text-align: center;

    > div:first-child {
      justify-content: center;
    }
  }
`;

Styled.LenderOfferCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

Styled.LenderOfferLabel = styled.div`
  font-weight: 500;
  font-size: 11px;
  line-height: 14px;
  letter-spacing: 0.4px;
  color: rgba(0, 27, 59, 0.6);
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 4px;
`;

Styled.LenderOfferValue = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: ${p => cardThemes[p.theme || 'green'].accent};
`;

Styled.LenderBalanceBig = styled.div`
  font-weight: 700;
  font-size: 22px;
  line-height: 26px;
  color: ${p => cardThemes[p.theme || 'green'].accent};
  margin-bottom: 12px;
`;

Styled.LenderBalanceSplit = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
`;

Styled.LenderBalanceSplitCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

Styled.LenderBalanceSplitLabel = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.6);
`;

Styled.LenderBalanceSplitValue = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: ${p => cardThemes[p.theme || 'green'].accent};
`;

Styled.LenderSelectButton = styled.button`
  background: #fff;
  border: 1px solid ${p => cardThemes[p.theme || 'green'].border};
  border-radius: 8px;
  padding: 12px 48px;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 1px;
  color: rgba(0, 27, 59, 0.94);
  cursor: pointer;
  margin-top: auto;
  align-self: center;
  text-transform: uppercase;

  &:hover {
    background: ${p => cardThemes[p.theme || 'green'].bg};
  }
`;

Styled.LenderCardInfoIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 1px solid rgba(0, 27, 59, 0.4);
  font-size: 9px;
  color: rgba(0, 27, 59, 0.6);
  cursor: help;
`;

/* ----- Lender selected state: 2-col layout + Manage Your Loan ----- */

Styled.LenderSplit = styled.div`
  padding: 0 150px 48px;
  display: grid;
  grid-template-columns: 375px 1fr;
  gap: 40px;
  align-items: start;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`;

Styled.FadeOutCard = styled.div`
  opacity: 0;
  transform: translateY(8px);
  transition: opacity 0.4s ease, transform 0.4s ease;
  pointer-events: none;
  height: 0;
  overflow: hidden;
`;

Styled.SelectedLenderWrapper = styled.div`
  animation: selectedSlideIn 0.5s ease forwards;

  @keyframes selectedSlideIn {
    from {
      transform: translateX(80px);
    }
    to {
      transform: translateX(0);
    }
  }
`;

Styled.ChooseDifferentLenderRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`;

Styled.ChooseDifferentLenderButton = styled.button`
  background: #fff;
  border: 1px solid rgba(45, 165, 72, 0.2);
  border-radius: 10px;
  padding: 10px 20px;
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  color: rgba(0, 27, 59, 0.75);
  cursor: pointer;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);

  &:hover {
    background: #F5F6F7;
  }
`;

Styled.ManageLoanPanel = styled.div`
  background: #fff;
  border: 1px solid rgba(42, 65, 105, 0.2);
  border-radius: 20px;
  padding: 32px 36px;
  opacity: 0;
  animation: managePanelFadeIn 0.5s ease forwards;
  animation-delay: 0.4s;

  @keyframes managePanelFadeIn {
    from {
      opacity: 0;
      transform: translateY(8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

Styled.ManageLoanTitle = styled.h3`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  color: rgba(0, 27, 59, 0.94);
  margin: 0 0 6px;
`;

Styled.ManageLoanSubtitle = styled.div`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #001B3B;
  margin-bottom: 20px;
`;

Styled.ManageLoanSection = styled.div`
  background: ${p => cardThemes[p.theme || 'green'].bg};
  border: 1px solid rgba(42, 65, 105, 0.2);
  border-radius: 20px;
  padding: 22px 28px;
  margin-bottom: 16px;
`;

Styled.ManageSectionTitle = styled.div`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: rgba(0, 27, 59, 0.94);
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
`;

Styled.ManageSectionDescription = styled.p`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.5);
  margin: 6px 0 16px;
`;

Styled.ManageInputRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

Styled.ManageAmountField = styled.div`
  flex: 1;
  background: #fff;
  border: 1px solid rgba(42, 65, 105, 0.2);
  border-radius: 10px;
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  gap: 6px;
`;

Styled.ManageAmountPrefix = styled.span`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 700;
  font-size: 24px;
  color: rgba(0, 27, 59, 0.38);
`;

Styled.ManageAmountInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 700;
  font-size: 24px;
  color: #001B3B;
  background: transparent;
  width: 100%;

  &::placeholder {
    color: rgba(0, 27, 59, 0.25);
  }
`;

Styled.ManagePostButton = styled.button`
  background: ${p => cardThemes[p.theme || 'green'].accent};
  border: 1px solid rgba(42, 65, 105, 0.2);
  border-radius: 5px;
  padding: 0 18px;
  height: 32px;
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 800;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.4px;
  color: #fff;
  cursor: pointer;

  &:hover {
    filter: brightness(0.95);
  }

  &:disabled {
    background: #BFC4CC;
    cursor: not-allowed;
  }
`;

Styled.ManageUpdateButton = styled.button`
  background: #2A4169;
  border: 1px solid rgba(42, 65, 105, 0.2);
  border-radius: 5px;
  padding: 0 18px;
  height: 32px;
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 800;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.4px;
  color: #fff;
  cursor: pointer;

  &:hover {
    filter: brightness(0.95);
  }

  &:disabled {
    background: #BFC4CC;
    color: #fff;
    cursor: not-allowed;
  }
`;

Styled.ManageMetaRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  gap: 8px;
  margin-top: 12px;
  font-family: 'Mukta Vaani', Lato, sans-serif;
`;

Styled.ManageMetaLabel = styled.span`
  font-weight: 500;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
`;

Styled.ManageMetaValue = styled.span`
  font-weight: 700;
  font-size: 16px;
  color: #001B3B;
`;

/* Confirm/notice modal reused inside Choose Your Lender */

Styled.LenderNoticeOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1600;
  display: flex;
  align-items: center;
  justify-content: center;
`;

Styled.LenderNoticeModal = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  padding: 32px;
  max-width: 480px;
  width: 90%;
  font-family: 'Mukta Vaani', Lato, sans-serif;
`;

Styled.LenderNoticeTitle = styled.h3`
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
  margin: 0 0 16px;
`;

Styled.LenderNoticeMessage = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.8);
  margin: 0 0 24px;
`;

Styled.LenderNoticeActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

Styled.LenderNoticeButton = styled.button`
  background: #2A4169;
  border: none;
  border-radius: 4px;
  padding: 8px 20px;
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #fff;
  cursor: pointer;

  &:hover {
    background: #1f3050;
  }
`;

Styled.LenderNoticeCancelButton = styled.button`
  background: #fff;
  border: 1px solid #CBD5E1;
  border-radius: 4px;
  padding: 8px 20px;
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: rgba(0, 27, 59, 0.7);
  cursor: pointer;

  &:hover {
    background: #F5F6F7;
    color: rgba(0, 27, 59, 0.94);
  }
`;

Styled.LenderNoticeTermsList = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr;
  row-gap: 8px;
  column-gap: 16px;
  margin: 4px 0 24px;
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-size: 16px;
  line-height: 22px;
  color: rgba(0, 27, 59, 0.94);
`;

Styled.LenderNoticeTermLabel = styled.div`
  color: rgba(0, 27, 59, 0.6);
  font-weight: 500;
`;

Styled.LenderNoticeTermValue = styled.div`
  font-weight: 700;
`;

/* ----- Choose Your Equity Investor (Equity Decisions) modal ----- */

const equityTheme = {
  border: '#A98DF6',
  accent: '#A98DF6',
  accentBold: '#AC86FF',
  badgeBg: '#EAE4F9',
  bgLight: 'rgba(169, 141, 246, 0.08)',
  bgMid: 'rgba(169, 141, 246, 0.12)',
  bgDark: 'rgba(169, 141, 246, 0.16)'
};

Styled.EquityStatusBar = styled.div`
  margin: 16px 150px 24px;
  background: #fff;
  border-radius: 12px;
  padding: 20px 28px;
  display: flex;
  align-items: flex-start;
  gap: 32px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
`;

Styled.EquityStatusValuation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-right: 24px;
  border-right: 1px solid #DEE0E3;
`;

Styled.EquityStatusSharePrice = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-right: 24px;
  border-right: ${p => p.last ? 'none' : '1px solid #DEE0E3'};
`;

Styled.EquityStatusLabel = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.6);
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;

Styled.EquityStatusValueBig = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  color: rgba(0, 27, 59, 0.94);
`;

Styled.EquityStatusSharesGroup = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

Styled.EquityStatusSharesHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

Styled.EquityStatusSharesHeaderLabel = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.6);
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;

Styled.EquityStatusSharesRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
`;

Styled.EquityStatusShareItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

Styled.EquityStatusShareItemLabel = styled.div`
  font-weight: 600;
  font-size: 11px;
  line-height: 14px;
  color: rgba(0, 27, 59, 0.6);
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;

Styled.EquityStatusShareItemValue = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  color: rgba(0, 27, 59, 0.94);
`;

Styled.EquityCard = styled.div`
  background: ${p =>
    p.shade === 'mid' ? equityTheme.bgMid :
    p.shade === 'dark' ? equityTheme.bgDark :
    equityTheme.bgLight};
  border: 1px solid ${equityTheme.border};
  border-radius: 20px;
  padding: 24px 22px;
  display: flex;
  flex-direction: column;

  ${p => p.noAnimation
    ? `opacity: 1;`
    : `
      opacity: 0;
      animation: fadeInEquity 0.5s ease forwards;
      animation-delay: ${(p.index || 0) * 500}ms;
    `}

  @keyframes fadeInEquity {
    from {
      opacity: 0;
      transform: translateY(8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

Styled.EquityCardTop = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 14px;
`;

Styled.EquityLogo = styled.div`
  width: 84px;
  height: 84px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid rgba(169, 141, 246, 0.2);
  flex-shrink: 0;
`;

Styled.EquityTitleArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

Styled.EquityName = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: rgba(0, 27, 59, 0.94);
  display: flex;
  align-items: center;
  gap: 6px;
`;

Styled.EquityTagline = styled.div`
  font-style: italic;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #4A4A4A;
`;

Styled.EquityStageBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  padding: 3px 14px;
  border-radius: 5px;
  font-weight: 700;
  font-size: 13px;
  line-height: 20px;
  background: ${equityTheme.badgeBg};
  color: ${equityTheme.accent};
  align-self: flex-start;

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${equityTheme.accent};
  }
`;

Styled.EquityDescription = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #001B3B;
  margin: 0 0 14px;
  min-height: 60px;
`;

Styled.EquityInnerCard = styled.div`
  background: #fff;
  border: 1px solid rgba(169, 141, 246, 0.2);
  border-radius: 10px;
  padding: 16px 18px;
  margin-bottom: 12px;
`;

Styled.EquityInnerLabel = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 27, 59, 0.5);
  text-transform: uppercase;
  margin-bottom: 8px;
`;

Styled.EquityInnerDescription = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 10px;
`;

Styled.EquityInnerBigValue = styled.div`
  font-weight: 800;
  font-size: 24px;
  line-height: 24px;
  color: ${equityTheme.accent};
`;

Styled.EquityExistingRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 12px;
`;

Styled.EquityExistingCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

Styled.EquityExistingLabel = styled.div`
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
  color: rgba(107, 114, 128, 0.8);
  text-transform: uppercase;
`;

Styled.EquityExistingValue = styled.div`
  font-weight: 800;
  font-size: 18px;
  line-height: 22px;
  color: ${equityTheme.accentBold};
`;

Styled.EquitySelectButton = styled.button`
  background: #fff;
  border: 1px solid rgba(169, 141, 246, 0.2);
  border-radius: 10px;
  padding: 11px 24px;
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.75);
  cursor: pointer;
  margin-top: auto;
  align-self: center;
  text-transform: uppercase;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);

  &:hover {
    background: ${equityTheme.bgLight};
  }
`;

/* === Decision Options panel (Issue / Buyback / Dividends) === */

Styled.DecisionOptionsWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

Styled.DecisionOptionsTitle = styled.h2`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  color: #001B3B;
  text-align: center;
  margin: 0 0 16px;
`;

Styled.DecisionTabBar = styled.div`
  background: rgba(0, 27, 59, 0.05);
  border: 1px solid rgba(42, 65, 105, 0.2);
  border-radius: 10px;
  padding: 8px;
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  width: 100%;
  max-width: 663px;
`;

Styled.DecisionTab = styled.button`
  flex: 1;
  background: ${p => p.active ? '#fff' : 'transparent'};
  border: ${p => p.active ? '1px solid rgba(42, 65, 105, 0.2)' : '1px solid transparent'};
  border-radius: 8px;
  padding: 12px 16px;
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: #001B3B;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: ${p => p.active ? '#fff' : 'rgba(255, 255, 255, 0.5)'};
  }
`;

Styled.DecisionPanel = styled.div`
  background: ${equityTheme.bgLight};
  border: 1px solid rgba(42, 65, 105, 0.2);
  border-radius: 20px;
  padding: 24px 36px 32px;
  width: 100%;
`;

Styled.DecisionPanelTitle = styled.div`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: rgba(0, 27, 59, 0.94);
  display: flex;
  align-items: center;
  gap: 6px;
`;

Styled.DecisionPanelSubtitle = styled.div`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.5);
  margin-top: 6px;
  margin-bottom: 24px;
`;

Styled.DecisionInputsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
`;

Styled.DecisionInputGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

Styled.DecisionInputLabel = styled.div`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 8px;
  text-transform: uppercase;
`;

Styled.DecisionAmountField = styled.div`
  background: #fff;
  border: 1px solid rgba(42, 65, 105, 0.2);
  border-radius: 10px;
  height: 50px;
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 14px;
`;

Styled.DecisionAmountPrefix = styled.span`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 700;
  font-size: 24px;
  color: rgba(0, 27, 59, 0.38);
  margin-right: 6px;
`;

Styled.DecisionAmountInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 700;
  font-size: 24px;
  color: #001B3B;
  min-width: 0;
  padding-right: ${p => p.hasButton ? '96px' : '0'};
  &::placeholder {
    color: rgba(0, 27, 59, 0.25);
  }
`;

Styled.DecisionAmountStatic = styled.div`
  flex: 1;
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 700;
  font-size: 24px;
  color: #001B3B;
`;

Styled.DecisionPostButton = styled.button`
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 27, 59, 0.94);
  border: 1px solid rgba(42, 65, 105, 0.2);
  border-radius: 5px;
  height: 25px;
  padding: 0 18px;
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 800;
  font-size: 14px;
  color: #fff;
  letter-spacing: 0.4px;
  cursor: pointer;

  &:hover { filter: brightness(0.85); }
  &:disabled {
    background: #BFC4CC;
    cursor: not-allowed;
  }
`;

Styled.DecisionUpdateButton = styled(Styled.DecisionPostButton)`
  background: #2A4169;
  &:disabled {
    background: #BFC4CC;
    color: #fff;
    cursor: not-allowed;
  }
`;

Styled.DecisionFooterRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: baseline;
  margin-top: 16px;
  font-family: 'Mukta Vaani', Lato, sans-serif;
`;

Styled.DecisionFooterLabel = styled.span`
  font-weight: 500;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
`;

Styled.DecisionFooterValue = styled.span`
  font-weight: 700;
  font-size: 16px;
  color: #001B3B;
`;

Styled.ManageButtonBar = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 16px;
  max-width: 1200px;
`;

Styled.ManageButton = styled.button`
  background: #2A4169;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 10px 24px;
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background: #36507e;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

Styled.ManageOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

Styled.ManageModal = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  padding: 28px 32px;
  max-width: 520px;
  width: 90%;
  font-family: 'Mukta Vaani', Lato, sans-serif;
`;

Styled.ManageModalTitle = styled.h3`
  font-weight: 700;
  font-size: 20px;
  line-height: 26px;
  color: rgba(0, 27, 59, 0.94);
  margin: 0 0 8px;
`;

Styled.ManageModalSubtitle = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.7);
  margin: 0 0 24px;
`;

Styled.ManageGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

Styled.ManageGroupLabel = styled.div`
  grid-column: 1 / -1;
  font-weight: 600;
  font-size: 14px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 8px;
  margin-bottom: -4px;

  &:first-child {
    margin-top: 0;
  }
`;

Styled.ManageOption = styled.button`
  background: #F5F6F7;
  border: 1px solid #D5D9DD;
  border-radius: 6px;
  padding: 14px 18px;
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: rgba(0, 27, 59, 0.94);
  cursor: pointer;
  text-align: left;

  &:hover {
    background: #EBF2FF;
    border-color: #5C91F5;
  }

  &:disabled {
    background: #F5F6F7;
    border-color: #D5D9DD;
    color: rgba(0, 27, 59, 0.4);
    cursor: not-allowed;
  }
`;

Styled.ManageOptionWrapper = styled.div`
  position: relative;
  display: flex;

  > button {
    width: 100%;
  }

  &:hover > span {
    opacity: 1;
    visibility: visible;
  }
`;

Styled.ManageOptionTooltip = styled.span`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(-8px);
  background: rgba(0, 27, 59, 0.94);
  color: #fff;
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  padding: 8px 12px;
  border-radius: 6px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.15s ease, visibility 0.15s ease;
  pointer-events: none;
  z-index: 10;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid transparent;
    border-top-color: rgba(0, 27, 59, 0.94);
  }
`;

Styled.ManageCloseRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;

Styled.ManageCloseButton = styled.button`
  background: transparent;
  border: 1px solid #D5D9DD;
  border-radius: 4px;
  padding: 8px 18px;
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: rgba(0, 27, 59, 0.8);
  cursor: pointer;
`;

Styled.TwoColumnSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  max-width: 1300px;
  margin-bottom: 16px;

  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
  }

  > div {
    margin-bottom: 0;
  }
`;


export default Styled;



// WEBPACK FOOTER //
// ./src/components/finance/style.js